/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "app",
  initialState: {
    theme: [],
    isAppInitializing: true,
    isFetchingLocale: true,
    notifications: {
      data: {},
      isLoading: false,
    },
    roles: [],
    event: {},
    isFetching: false,
    locale: "en",
  },
  reducers: {
    fetchThemeRequest: (state) => {
      state.isAppInitializing = true;
    },
    fetchThemeSuccess: (state, { payload }) => {
      state.theme = payload;
      state.isAppInitializing = false;
    },
    fetchThemeFailure: (state, { payload }) => {
      state.isAppInitializing = false;
    },
    fetchNotificationsRequest: (state) => {
      state.notifications.isLoading = true;
    },
    fetchNotificationsSuccess: (state, { payload }) => {
      state.notifications.data = payload;
      state.notifications.isLoading = false;
    },
    fetchRolesRequest: (state) => {
      state.isFetching = true;
    },
    fetchRolesSuccess: (state, { payload }) => {
      state.roles = payload;
      state.isFetching = false;
    },
    fetchRolesFailure: (state, { payload }) => {
      state.isFetching = false;
    },
    fetchEventRequest: (state) => {
      state.isFetching = true;
    },
    fetchEventSuccess: (state, { payload }) => {
      state.event = payload;
      state.isFetching = false;
    },
    fetchEventsFailure: (state, { payload }) => {
      state.isFetching = false;
    },
    fetchLocaleRequest: (state) => {
      state.isFetchingLocale = true;
    },
    fetchLocaleSuccess: (state, { payload }) => {
      state.locale = payload;
      state.isFetchingLocale = false;
    },
    fetchLocaleFailure: (state, { payload }) => {
      state.isFetchingLocale = false;
    },
  },
});

export const {
  fetchThemeRequest,
  fetchThemeSuccess,
  fetchThemeFailure,
  fetchNotificationsRequest,
  fetchNotificationsSuccess,
  fetchRolesRequest,
  fetchRolesSuccess,
  fetchRolesFailure,
  fetchEventRequest,
  fetchEventSuccess,
  fetchEventsFailure,
  fetchLocaleRequest,
  fetchLocaleSuccess,
  fetchLocaleFailure,
} = slice.actions;

export const { reducer } = slice;
